module.exports = __webpack_public_path__ + "static/media/enchanting-1.d65206b4.png";